import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import FirebaseStore from 'stores/FirebaseStore';
import ProfileStore from 'stores/ProfileStore';
import Button from 'components/Button/Button';
import { secondsToTime } from 'utils/helpers';
import useInterval from 'hooks/useInterval';
import ThemeService from 'themes/ThemeService';
import { MINUTE_AS_SECONDS, SECOND_AS_MILLISECONDS } from 'enum/timeFormat';

import styles from './BoostButton.css';


const DEFAULT_DURATION_MINUTES = 5;
const DEFAULT_EXTENDED_DURATION_MINUTES = 25;

function BoostButton(props) {
  const { onClick, id } = props;
  const { boostRemainingTime } = FirebaseStore;
  const { isPlayerBroadcastMode } = ProfileStore;

  const [boostTimer, setBoostTimer] = useState(null);

  const duration = window.BOOSTED_ROOM_DURATION_MINUTES || DEFAULT_DURATION_MINUTES;
  const extendedDuration = window.BOOSTED_ROOM_EXTENDED_DURATION_MINUTES || DEFAULT_EXTENDED_DURATION_MINUTES;
  const totalDuration = duration + extendedDuration;

  useInterval(() => {
    const timeLeft = moment(boostRemainingTime).add(extendedDuration, 'minutes').diff(moment(), 'seconds');
    const timePassed = (totalDuration * MINUTE_AS_SECONDS) - timeLeft;
    const formatted = secondsToTime(timePassed);
    if (isNaN(timePassed)) {
      setBoostTimer(null);
    } else {
      setBoostTimer(formatted);
    }
  }, [boostRemainingTime ? SECOND_AS_MILLISECONDS : null]);

  const handleClick = useCallback(() => {
    if (!boostRemainingTime) {
      onClick();
    }
  }, [boostRemainingTime, onClick]);

  const iconEl = <img alt="boost icon" src={ThemeService.theme.boost.icon} />;

  return (
    <div className={styles.container}>
      <Button
        className={styles.btn}
        disabled={isPlayerBroadcastMode}
        icon={iconEl}
        id={id}
        onClick={handleClick}
      />
      {Boolean(boostRemainingTime) && (
        <div
          className={styles.timer}
          id={`${id}_lockTimer`}
        >
          {boostTimer}
        </div>
      )}
    </div>
  );
}

BoostButton.propTypes = {
  id: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default BoostButton;
